import { routes } from '@/app/routing/router'
import { StarterPackClaimPage } from './view'

const currentRoute = routes.starterPackClaim

const StarterPackClaimRoute = {
  route: currentRoute,
  view: StarterPackClaimPage,
}

export { currentRoute, StarterPackClaimRoute }
